const styles = {
  loadingIcon: {
    animation: 'spin 1.5s linear infinite',
    '@keyframes spin': {
      '0%': {
        transform: 'rotate(360deg)',
      },
      '100%': {
        transform: 'rotate(0deg)',
      },
    },
  },
  snackbar: (theme) => ({
    maxWidth: 600,
    minWidth: 300,
    bottom: 89 + 40,
    right: 0,
    left: 0,
    [theme.breakpoints.up('sm')]: {
      right: 40,
      left: 'auto',
      bottom: 105 + 40,
    },
    '.MuiLink-underlineAlways': {
      textDecorationColor: 'inherit',
    },
  }),
};

export default styles;
